export default __webpack_public_path__ + "static/loading-1b2d9371cdecf68407ac8807682b4bac.gif";